import Vue from 'vue'

export default {
  namespaced: true,
  state: {
    items: [],
    item: {},
    total: 0,
  },
  getters: {
    items: state => state.items,
    item: state => state.item,
    total: state => state.total,
  },
  mutations: {
    SAVE_ITEMS(state, items) {
      state.items = items
    },
    SAVE_ITEM(state, item) {
      state.item = item
    },
    CLEAR_ITEM(state) {
      state.item = {}
      state.items = {}
    },
    SAVE_TOTAL(state, total) {
      state.total = total
    },
  },
  actions: {
    async filter({ commit }, filters) {
      try {
        commit('CLEAR_ITEM')
        const resp = await Vue.prototype.$http.post(`${Vue.prototype.$groupUrl}/mail-loggers/filter`, filters)
        commit('SAVE_TOTAL', resp.data.total)
        commit('SAVE_ITEMS', resp.data.data)
      } catch (e) {
        commit('CLEAR_ITEM')
      }
    },
  },
}
